import { Center } from "@chakra-ui/react"
import React from "reactn"
import { StoryCard } from "./story-card"
import { Wrap, WrapItem } from '@chakra-ui/react'

export function StoryListing({ seo, location, stories = [] }) {
  return (
    <Center>
      <Wrap
        justify='center'
        spacing={['50px', '50px', '100px', '150px']}
        id="storyItemWrap">
        {stories.map((s, index) => (
          <WrapItem id="storyListItemWrap" >
            <StoryCard story={s} key={s.id} eager={index === 0} seo={seo} location={location} />
          </WrapItem>
        ))}
      </Wrap>
    </Center>
  )
}
